module.exports = __webpack_public_path__ + "/images/screen-vendedores-catalogo.a5bc37b.webp";